import { render, staticRenderFns } from "./ContratosGuardados.vue?vue&type=template&id=dccbc474&"
import script from "./ContratosGuardados.vue?vue&type=script&lang=js&"
export * from "./ContratosGuardados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports